var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[(_vm.info.image)?_c('img',{attrs:{"src":_vm.info.image,"alt":""}}):_vm._e(),_c('div',{domProps:{"innerHTML":_vm._s(_vm.info.text)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }